import { CART_ITEM_TYPE, DEFAULT_CART_ITEM_VIEW_MODEL } from '../../../reducers/constants/products.wizard.constants';
var _createCartItem = function createCartItem(item) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var grossAmount = item.GrossRenewAmount ? item.GrossRenewAmount : item.PricingPlan.RenewalChargeAmount;
  var totalAmount = item.RenewAmount ? item.RenewAmount : item.PricingPlan.RenewalChargeAmount;
  var currencyCode = item.Currency ? item.Currency : item.PricingPlan.Currency;
  var brandableCurrencyName = item.BrandableCurrencyName ? item.BrandableCurrencyName : item.PricingPlan.BrandableCurrencyName;
  return Object.assign({}, DEFAULT_CART_ITEM_VIEW_MODEL, {
    childItems: item.Children && item.Children.length > 0 ? item.Children.map(_createCartItem) : [],
    discountAmount: grossAmount - totalAmount,
    grossAmount: grossAmount,
    totalAmount: totalAmount,
    name: item.Product.Name,
    pricingPlanName: item.PricingPlan.Name,
    pricingPlanId: item.PricingPlan.Id,
    productId: item.Product.Id,
    instanceProperties: item.InstanceProperties,
    quantity: 1,
    id: item.Id,
    index: index,
    isEditable: false,
    isRemovable: false,
    itemType: CART_ITEM_TYPE.REMOVAL,
    currencyCode: currencyCode,
    brandableCurrencyName: brandableCurrencyName
  });
};
export var createSubscriptionCartItem = function createSubscriptionCartItem(fullSubscription, editingSubscriptionItemId) {
  var subscriptionItem = null;
  if (fullSubscription) {
    if (fullSubscription.Items.length > 1 && editingSubscriptionItemId) {
      subscriptionItem = fullSubscription.Items.find(function (subItem) {
        return subItem.Id === editingSubscriptionItemId;
      });
    }
    return _createCartItem(subscriptionItem || fullSubscription.Items[0]);
  } else {
    return {};
  }
};